module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "text-center"
  }, [_c('v-menu', {
    attrs: {
      "close-on-content-click": "",
      "nudge-width": 100,
      "left": "",
      "offset-x": "",
      "attach": ""
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;
        var attrs = ref.attrs;

        return [_c('v-btn', _vm._g(_vm._b({
          staticClass: "mx-2",
          attrs: {
            "fab": "",
            "dark": "",
            "small": "",
            "color": "primary",
            "elevation": "24"
          }
        }, 'v-btn', attrs, false), on), [_c('v-icon', {
          attrs: {
            "small": "",
            "dark": ""
          }
        }, [_vm._v("\n          mdi-plus-thick\n        ")])], 1)]
      }
    }]),
    model: {
      value: (_vm.menu),
      callback: function($$v) {
        _vm.menu = $$v
      },
      expression: "menu"
    }
  }, [_vm._v(" "), _c('v-card', [_c('v-list', _vm._l((_vm.menuItems), function(item, index) {
    return _c('v-list-item', {
      key: index,
      staticClass: "list-item",
      on: {
        "click": function($event) {
          return _vm.$emit('select', index)
        }
      }
    }, [_c('v-list-item-content', [_c('v-list-item-title', {
      staticClass: "menu-item-name"
    }, [_vm._v(_vm._s(item.name))])], 1)], 1)
  }), 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-96ac2d8e"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/app/appComponents/common/NewItemMenu.vue
// module id = 1972
// module chunks = 0